var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "l-header u-row cl-white" },
    [
      _c(
        "router-link",
        { staticClass: "logo", attrs: { to: "/" } },
        [_c("icon-logo")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav u-flex u-row" },
        [
          _c(
            "router-link",
            {
              class: { "w5 cl-yellow": _vm.$route.name === "dashboard" },
              attrs: { to: { name: "dashboard", query: _vm.$route.query } }
            },
            [_vm._v("レポート")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              class: { "w5 cl-yellow": _vm.$route.name === "deals" },
              attrs: { to: { name: "deals", query: _vm.$route.query } }
            },
            [_vm._v("物件データ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.account
        ? _c("ui-dropdown", {
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var active = ref.active
                    var toggle = ref.toggle
                    return [
                      _c(
                        "a",
                        { staticClass: "account u-row", on: { click: toggle } },
                        [
                          _c("icon-dropdown"),
                          _vm._v(" "),
                          _c("p", { staticClass: "u-flex" }, [
                            _vm._v(_vm._s(_vm.account.personal.fullname))
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "u-fr",
                            attrs: { src: "/images/avatar.png" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: active,
                              expression: "active"
                            }
                          ],
                          staticClass: "menu"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "u-row",
                              attrs: { href: _vm.settings }
                            },
                            [
                              _c("icon-settings"),
                              _vm._v(" "),
                              _c("span", [_vm._v("設定")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "u-row",
                              on: {
                                click: function($event) {
                                  return _vm.destroy()
                                }
                              }
                            },
                            [
                              _c("icon-logout"),
                              _vm._v(" "),
                              _c("span", [_vm._v("ログアウト")])
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              3450898553
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }